import React from 'react'
import { Link } from 'react-router'

export default class LinkDashboard extends React.Component {
  render () {
    alert("url")
    var url = 'estadoSaludDashboard/' + this.props.rowData.Identificación
    return (
      <Link to={url}>{this.props.data}</Link>
    )
  }
}

/* Validate Props */
LinkDashboard.propTypes = {
  rowData: React.PropTypes.object,
  data: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Search/LinkDashboard.js